import settings from '../../settings';
let baseUrl = settings.apiBaseUrl;
export default {
    // Endpoints
    auth: {
        login: `${baseUrl}/api/v1/auth/login`,
        logout: `${baseUrl}/api/v1/auth/logout`,
        refresh: `${baseUrl}/api/v1/auth/refresh`,
        profile: `${baseUrl}/api/v1/auth/profile`,
        register: `${baseUrl}/api/v1/auth/register`,
    },

    // Languages

    languages: {
        get: `${baseUrl}/api/v1/dashboard/languages`,
        getById: `${baseUrl}/api/v1/dashboard/language`,
        post: `${baseUrl}/api/v1/dashboard/language`,
        put: `${baseUrl}/api/v1/dashboard/language/update`,
        putOrder: `${baseUrl}/api/v1/dashboard/languages/order`,
        delete: `${baseUrl}/api/v1/dashboard/language`,
    },

    translations: {
        get: `${baseUrl}/api/v1/dashboard/translations`,
        getById: `${baseUrl}/api/v1/dashboard/translation`,
        post: `${baseUrl}/api/v1/dashboard/translation`,
        put: `${baseUrl}/api/v1/dashboard/translation/update`,
        putOrder: `${baseUrl}/api/v1/dashboard/translation/order`,
        delete: `${baseUrl}/api/v1/dashboard/translation`,
    },

    products: {
        get: `${baseUrl}/api/v1/dashboard/products`,
        getById: `${baseUrl}/api/v1/dashboard/product`,
        post: `${baseUrl}/api/v1/dashboard/product`,
        postTranslation: `${baseUrl}/api/v1/dashboard/product/translation`,
        putTranslation: `${baseUrl}/api/v1/dashboard/product/translation/update`,
        putOrder: `${baseUrl}/api/v1/dashboard/products/order`,
        delete: `${baseUrl}/api/v1/dashboard/product`,
    },

    questions: {
        get: `${baseUrl}/api/v1/dashboard/questions`,
        getById: `${baseUrl}/api/v1/dashboard/question`,
        post: `${baseUrl}/api/v1/dashboard/question`,
        postTranslation: `${baseUrl}/api/v1/dashboard/question/translation`,
        putTranslation: `${baseUrl}/api/v1/dashboard/question/translation/update`,
        putOrder: `${baseUrl}/api/v1/dashboard/question/order`,
        delete: `${baseUrl}/api/v1/dashboard/question`,
    },

    productQuestions: {
        getById: `${baseUrl}/api/v1/dashboard/product-questions`,
        getQuestionById: `${baseUrl}/api/v1/dashboard/product-question`,
        post: `${baseUrl}/api/v1/dashboard/product-question`,
        put: `${baseUrl}/api/v1/dashboard/product-question/update`,
        putOrder: `${baseUrl}/api/v1/dashboard/product-questions/order`,
        delete: `${baseUrl}/api/v1/dashboard/product-question`,
    },

    analysisResults: {
        get: `${baseUrl}/api/v1/dashboard/analysis-results`,
        getById: `${baseUrl}/api/v1/dashboard/analysis-result`,
    },

    categories: {
        get: `${baseUrl}/api/v1/dashboard/categories`,
        getFlat: `${baseUrl}/api/v1/dashboard/categories/flat`,
        getTree: `${baseUrl}/api/v1/dashboard/categories/tree`,
        getAttributes: `${baseUrl}/api/v1/dashboard/categories/attributes`,
        put: `${baseUrl}/api/v1/dashboard/categories/update`,
        post: `${baseUrl}/api/v1/dashboard/categories`,
        postTranslation: `${baseUrl}/api/v1/dashboard/categories/translation`,
        order: `${baseUrl}/api/v1/dashboard/categories/order`,
        delete: `${baseUrl}/api/v1/dashboard/categories`,
    },
    contents: {
        get: `${baseUrl}/api/v1/dashboard/contents`,
        getByCategorySlug: `${baseUrl}/api/v1/dashboard/contents/categories`,
        put: `${baseUrl}/api/v1/dashboard/contents/update`,
        post: `${baseUrl}/api/v1/dashboard/contents`,
        postAvailability: `${baseUrl}/api/v1/dashboard/contents/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/contents/translation`,
        order: `${baseUrl}/api/v1/dashboard/contents/order`,
        delete: `${baseUrl}/api/v1/dashboard/contents`,
    },

    devices: {
        get: `${baseUrl}/api/v1/dashboard/devices`,
        getById: `${baseUrl}/api/v1/dashboard/device`,
        post: `${baseUrl}/api/v1/dashboard/device`,
        put: `${baseUrl}/api/v1/dashboard/device/update`,
        delete: `${baseUrl}/api/v1/dashboard/device`,
    },

    users: {
        get: `${baseUrl}/api/v1/dashboard/users`,
        getById: `${baseUrl}/api/v1/dashboard/user`,
        post: `${baseUrl}/api/v1/dashboard/user`,
        put: `${baseUrl}/api/v1/dashboard/user/update`,
        delete: `${baseUrl}/api/v1/dashboard/user`,
        delete: `${baseUrl}/api/v1/dashboard/user`,
    },

    airports: {
        get: `${baseUrl}/api/v1/dashboard/airports`,
        getAll: `${baseUrl}/api/v1/dashboard/airports/all`,
        post: `${baseUrl}/api/v1/dashboard/airport`,
        delete: `${baseUrl}/api/v1/dashboard/airport`,
    },

    airportProducts: {
        getById: `${baseUrl}/api/v1/dashboard/airport/products`,
        post: `${baseUrl}/api/v1/dashboard/airport/products`,
        delete: `${baseUrl}/api/v1/dashboard/airport/products`,
    },
    educators: {
        get: `${baseUrl}/api/v1/dashboard/educators`,
        getByCategorySlug: `${baseUrl}/api/v1/dashboard/educators/categories`,
        put: `${baseUrl}/api/v1/dashboard/educators/update`,
        post: `${baseUrl}/api/v1/dashboard/educators`,
        postAvailability: `${baseUrl}/api/v1/dashboard/educators/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/educators/translation`,
        order: `${baseUrl}/api/v1/dashboard/educators/order`,
        delete: `${baseUrl}/api/v1/dashboard/educators`,
    },
    sliders: {
        get: `${baseUrl}/api/v1/dashboard/sliders`,
        put: `${baseUrl}/api/v1/dashboard/sliders/update`,
        post: `${baseUrl}/api/v1/dashboard/sliders`,
        postTranslation: `${baseUrl}/api/v1/dashboard/sliders/translation`,
        order: `${baseUrl}/api/v1/dashboard/sliders/order`,
        delete: `${baseUrl}/api/v1/dashboard/sliders`,
    },
    events: {
        get: `${baseUrl}/api/v1/dashboard/events`,
        put: `${baseUrl}/api/v1/dashboard/events/update`,
        post: `${baseUrl}/api/v1/dashboard/events`,
        postAvailability: `${baseUrl}/api/v1/dashboard/events/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/events/translation`,
        order: `${baseUrl}/api/v1/dashboard/events/order`,
        delete: `${baseUrl}/api/v1/dashboard/events`,
    },
    books: {
        get: `${baseUrl}/api/v1/dashboard/books`,
        put: `${baseUrl}/api/v1/dashboard/books/update`,
        post: `${baseUrl}/api/v1/dashboard/books`,
        postTranslation: `${baseUrl}/api/v1/dashboard/books/translation`,
        order: `${baseUrl}/api/v1/dashboard/books/order`,
        delete: `${baseUrl}/api/v1/dashboard/books`,
    },
    podcasts: {
        get: `${baseUrl}/api/v1/dashboard/podcasts`,
        put: `${baseUrl}/api/v1/dashboard/podcasts/update`,
        post: `${baseUrl}/api/v1/dashboard/podcasts`,
        postAvailability: `${baseUrl}/api/v1/dashboard/podcasts/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/podcasts/translation`,
        order: `${baseUrl}/api/v1/dashboard/podcasts/order`,
        delete: `${baseUrl}/api/v1/dashboard/podcasts`,
    },
    galleries: {
        get: `${baseUrl}/api/v1/dashboard/galleries`,
        put: `${baseUrl}/api/v1/dashboard/galleries/update`,
        post: `${baseUrl}/api/v1/dashboard/galleries`,
        postAvailability: `${baseUrl}/api/v1/dashboard/galleries/availability`,
        postTranslation: `${baseUrl}/api/v1/dashboard/galleries/translation`,
        order: `${baseUrl}/api/v1/dashboard/galleries/order`,
        delete: `${baseUrl}/api/v1/dashboard/galleries`,
    },
    settingsSliderHighlights: {
        get: `${baseUrl}/api/v1/dashboard/settings/highlights`,
        post: `${baseUrl}/api/v1/dashboard/settings/highlights`,
        order: `${baseUrl}/api/v1/dashboard/settings/highlights/order`,
        delete: `${baseUrl}/api/v1/dashboard/settings/highlights`,
    },
    settingsSliderPrograms: {
        get: `${baseUrl}/api/v1/dashboard/settings/programs`,
        post: `${baseUrl}/api/v1/dashboard/settings/programs`,
        order: `${baseUrl}/api/v1/dashboard/settings/programs/order`,
        delete: `${baseUrl}/api/v1/dashboard/settings/programs`,
    },
    settingsSliderInteresteds: {
        get: `${baseUrl}/api/v1/dashboard/settings/interesteds`,
        post: `${baseUrl}/api/v1/dashboard/settings/interesteds`,
        order: `${baseUrl}/api/v1/dashboard/settings/interesteds/order`,
        delete: `${baseUrl}/api/v1/dashboard/settings/interesteds`,
    },

    settingsSliderPodcasts: {
        get: `${baseUrl}/api/v1/dashboard/settings/podcasts`,
        post: `${baseUrl}/api/v1/dashboard/settings/podcasts`,
        delete: `${baseUrl}/api/v1/dashboard/settings/podcasts`,
    },

    form: {
        gsys: {
            get: `${baseUrl}/api/v1/dashboard/forms/gsys`,
        },
        contacts: {
            get: `${baseUrl}/api/v1/dashboard/forms/contacts`,
        },
        newsletters: {
            get: `${baseUrl}/api/v1/dashboard/forms/newsletters`,
        },
        participants: {
            get: `${baseUrl}/api/v1/dashboard/forms/participants`,
        }
    },

    eventTypes: {
        get: `${baseUrl}/api/v1/dashboard/event-types`,
    },
    categoryTypes: {
        get: `${baseUrl}/api/v1/dashboard/category-types`,
    },
    contentTypes: {
        get: `${baseUrl}/api/v1/dashboard/content-types`,
    },
    sliderLinkTypes: {
        get: `${baseUrl}/api/v1/dashboard/slider-link-types`,
    },
    galleryCategories: {
        get: `${baseUrl}/api/v1/dashboard/gallery-categories`,
    },
    upload: {
        file: `${baseUrl}/api/v1/dashboard/upload/file`,
        image: `${baseUrl}/api/v1/dashboard/upload/image`,
        imageByUrl: `${baseUrl}/api/v1/dashboard/upload/image/by-url`,

    }

}